
import axios, { AxiosResponse } from 'axios';
import i18n from '../i18n';

let BASE_PATH = process.env.REACT_APP_API_BASE_URL;

if (!BASE_PATH) {
    throw new Error('API base URL is not defined in the environment variables');
}

// Helper: Convert Blob error → JSON
const blobToJson = (blob: Blob): Promise<any> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            try {
                resolve(JSON.parse(reader.result as string));
            } catch (e) {
                reject("Failed to parse Blob JSON");
            }
        };
        reader.onerror = () => reject("Error reading Blob");
        reader.readAsText(blob);
    });
};

export const fetchData = async <T = any>(
    url: string,
    apiKey: string,
    responseType: 'json' | 'blob' = 'json',

): Promise<AxiosResponse<T>> => {
    const lang = i18n.language || 'en';

    try {
        const headers: Record<string, string> = {
            'x-api-key': apiKey,
            'x-display-culture': lang,   // <-- always sent
            'x-user-culture': lang       // <-- always sent
        };
        const response = await axios.get<T>(BASE_PATH + url, {
            headers,
            responseType: responseType,
        });
        //console.log("RESPONSE fetchData ", JSON.stringify(response))
        return response; // Return the full Axios response
    }
    catch (error: any) {
        console.error('34 catch Error in fetchData:', error);



        console.error("Error in fetchData:", error);


        if (axios.isAxiosError(error)) {
            const rawData = error.response?.data;
            const status = error.response?.status;

            // If error is a Blob → convert Blob → JSON
            if (rawData instanceof Blob) {
                try {
                    const json = await blobToJson(rawData);
                    throw { ...json, status };   // <-- IMPORTANT
                } catch (parseErr) {
                    throw {

                        status,
                        data: parseErr
                    };
                }
            }

            // Normal JSON returned by backend
            if (rawData) {
                throw { data: rawData, status };    // <-- ADD status
            }

            throw {
                key: "axios_error",
                source: "client",
                message: error.message,
                status
            };
        }

        // Non-axios error
        throw {
            key: "unexpected",
            source: "client",
            message: "Unexpected error occurred",
            status: 0
        };

    }
}




